import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from '../components/Logo';
import { Footer } from '../components/Footer';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const { forgotPassword } = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const { error } = await forgotPassword(email.trim());
    setSubmitting(false);
    if (error) { toast.error(error.message); return; }
    setSent(true);
  };

  return (
    <div className="min-h-screen flex flex-col relative z-10" data-testid="forgot-page">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-primary mb-8 flex justify-center"><Logo /></div>
        <div className="rounded-2xl border border-border bg-card p-7 sm:p-9">
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Reset password</h1>
          <p className="text-sm text-muted-foreground mt-1.5">We&apos;ll email you a secure reset link.</p>
          {sent ? (
            <div className="mt-6 text-sm text-muted-foreground" data-testid="forgot-sent">
              If an account exists for <span className="text-foreground font-medium">{email}</span>, a reset link is on its way.
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={submitting} className="w-full rounded-full" data-testid="forgot-submit">
                {submitting && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
                Send reset link
              </Button>
            </form>
          )}
          <p className="mt-6 text-sm text-center text-muted-foreground">
            <Link to="/login" className="text-foreground font-medium hover:underline" data-testid="forgot-back-link">Back to sign in</Link>
          </p>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
